<!--<mat-drawer-container hasBackdrop>-->
<!--    <mat-drawer class="invoice-details" #drawer mode="over" position="end">-->
<!--        <div class="drawer-header" fxLayout="row" fxLayoutAlign="space-between center">-->
<!--            <span class="invoice-details-header">-->
<!--                <p>Invoice Information</p>-->
<!--            </span>-->
<!--            <button-->
<!--                    color="primary"-->
<!--                    class="invoice-details-close-button"-->
<!--                    mat-icon-button-->
<!--                    (click)="drawer.close()">-->
<!--                <mat-icon>close</mat-icon>-->
<!--            </button>-->
<!--        </div>-->

<!--        <mat-divider></mat-divider>-->

<!--        <div class="drawer-content">-->
<!--            <div class="invoice-details-title">-->
<!--                <h4>Invoice Details</h4>-->
<!--            </div>-->

<!--        </div>-->
<!--    </mat-drawer>-->

<!--    <mat-drawer-content>-->
        <div class="invoice-visualising-container">
            <div #documentViewer class="document-viewer">
                <pdf-viewer
                        *ngIf="pdfsrc !== undefined; else imageViewer"
                        [src]="pdfsrc"
                        [autoresize]="true"
                        [original-size]="false"
                        [render-text]="false"
                        style="width: 100%; height: 100%">
                </pdf-viewer>

                <ng-template #imageViewer>
                    <canvas #canvas></canvas>
                </ng-template>
            </div>

            <div class="action-buttons">
                <button
                        class="download-button"
                        mat-fab
                        (click)="downloadAttachment()"
                        color="accent"
                        matTooltip="Invoice Information">
                    <mat-icon>save_alt</mat-icon>
                </button>
            </div>
        </div>
<!--    </mat-drawer-content>-->
<!--</mat-drawer-container>-->
